/**
 * Tabs
 */

const $tabs = $('.js-tabs');
const $mobileTabs = $('.js-tabs.tabs--mobile-accordion')
const MOBILE_WIDTH = 767;

/**
 * Tabs 
 */
$tabs.on('click', '.tabs__nav a', function(evt) {
	evt.preventDefault();
	$target = $(this).parent();
	$target.addClass('is-current')
		 	.siblings()
		 	.removeClass('is-current');
	$tabs
		.find('.tab')
		.eq($target.index())
		.addClass('is-current')
		.siblings()
			.removeClass('is-current');
});

/**
 * Mobile tabs to accordion
 */

$mobileTabs.on('click', '.tabs__accordion-trigger', function(evt) {
	evt.preventDefault();

	const tabParents = $(this).parentsUntil('.tabs');
	const $tabsContainer = $(tabParents[tabParents.length - 1]);
	const TABS__OFFSET = 59;

	$(this).parent()
		.find('.tab__content')
		.slideToggle()
		.end()
		.toggleClass('is-current')
		.siblings()
			.removeClass('is-current')
			.find('.tab__content')
			.slideUp();

	$('html').animate({
		scrollTop: $tabsContainer.offset().top - TABS__OFFSET
	},400);
});


/**
 * Fix functionality on resize
 */

$(window).on('resize', function(evt) {
	evt.preventDefault();

	// Check if user is on mobile
	if (deviceIsMobile()) {
		$mobileTabs
			.find('.tab:not(.is-current) .tab__content')
				.hide();
		return;
	}

	// Check if no tabs are active on resize

	if ($('.tabs__body').find('.is-current').length === 0) {
		$mobileTabs
			.find('.tabs__nav li:first-of-type')
				.addClass('is-current')
			.end()
			.find('.tabs__body .tab:first-of-type')
				.addClass('is-current');

		return;
	}

	// Reset tabs functionality

	$mobileTabs
		.find('.tab__content')
			.show()
		.end()
		.find('.tabs__nav li')
			.eq($('.tab.is-current').index())
				.addClass('is-current')
			.siblings()
				.removeClass('is-current');
});


/**
 * Check if user is on mobile
 *
 * @return {Void}
 */

const deviceIsMobile = () => $(window).outerWidth() <= MOBILE_WIDTH;
